
import styled, { keyframes } from "styled-components";
// Animations for the AI Look
const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 0.8; }
  50% { transform: scale(1.1); opacity: 1; }
`;

// Styled container for centering
const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  background: transparent;
  margin-bottom: 30px;
`;

const LoaderMessage = styled.div`
  margin-top: 24px;
  color: #000000;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 1px;
`;
const LoaderFullPageWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  background: rgb(255 255 255 / 68%);
  backdrop-filter: blur(2px);
`;
const AIOrbital = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  /* Outer AI Ring */
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px dashed #005a9c; /* Theme Blue */
    animation: ${rotate} 4s linear infinite;
  }

  /* Inner Orange Glow */
  &::after {
    content: "";
    position: absolute;
    width: 80%;
    height: 80%;
    border-radius: 50%;
    border: 3px solid #f26522; /* Theme Orange */
    opacity: 0.3;
    animation: ${pulse} 2s ease-in-out infinite;
  }
`;

const CignaImage = styled.img`
  width: 40px;
  height: auto;
  z-index: 2;
  filter: drop-shadow(0 0 10px rgba(0, 90, 156, 0.2));
`;

const CignaLoader = ({
    loading = false,
    fullPage = false,
    loadingMessage = ""
}) => {

    const getInner = () => {
      return (
        <>
          <AIOrbital>
            <CignaImage src="/erenewal/cigna.png" />
          </AIOrbital>
          <LoaderMessage>
            {loadingMessage}
          </LoaderMessage>
        </>
      );
    };

  return (
    loading && (fullPage ? <LoaderFullPageWrapper>{getInner()}</LoaderFullPageWrapper> : <LoaderWrapper>{getInner()}</LoaderWrapper>)
  );
};

export default CignaLoader;
